import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";
import { Outlet } from "react-router-dom";

export default function ProtectedRoute({ role }) {
    const { user } = useContext(AuthContext);

    if (!user) return <Navigate to="/" />;

    // superadmin can access any role-protected route
    if (role && user.role !== role && user.role !== 'superadmin') {
        return <Navigate to="/" />;
    }

    return <Outlet />;
}